import { defineStore } from "pinia"

export const useAuthStore = defineStore("auth", {
  state: () => ({
    ownerPhoneNumber: null,
    authStore: {
      token: null,
      refreshToken: null,
      role: [],
    },
    isLogin: false,
    expireTokenTime: null,
    isExpireTime: false,
  }),
  actions: {
    setPhoneNumber(value) {
      this.ownerPhoneNumber = value
    },
    setAuthStore(value) {
      this.authStore.token = value.token
      this.authStore.refreshToken = value.refreshToken
      this.authStore.role = value.role
    },
    setIsLogin(value) {
      this.isLogin = value
    },
    setExpireTime(value) {
      this.expireTokenTime = value
    },
    setIsExpire(value) {
      this.isExpireTime = value
    },
    clearAuthData() {
      this.authStore.token = null
      this.authStore.refreshToken = null
      this.authStore.role = []
      this.ownerPhoneNumber = null
      this.isLogin = false
    },
  },
})
